import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { getAmendAppointmentInfo } from 'features/order-tracker/store/selectors';
import { setIsReadyToConfirm } from 'features/order-tracker/store/actions';
import { ANALYTICS_APPT_SAVE_AMENDS } from './constants';

import styles from './styles.module.scss';

export const SaveAmendsButton: React.FC = () => {
  const dispatch = useDispatch();
  const {
    addingNewContact,
    selectedSlot,
    initialContactKey,
    selectedContact,
  } = useSelector(getAmendAppointmentInfo);
  const newContactSelected = initialContactKey !== selectedContact;
  const isHidden = !selectedSlot && !newContactSelected || addingNewContact;

  return (
    <div className={classNames(styles.saveAmendsButtonContainer, { [styles.hidden]: isHidden })}>
      <div className={styles.innerContainer}>
        <button
          onClick={() => dispatch(setIsReadyToConfirm(true))}
          className={styles.saveAmendsButton}
          data-analytics-link={ANALYTICS_APPT_SAVE_AMENDS}
          type="button"
        >
          Save amends to appointment
        </button>
      </div>
    </div>
  );
};
